export const staircaseConfig = {
    gameSlug: 'train-of-thought',
    category: 'air_attention',
    // Intervalle entre spawns (ms). Plus c'est long, plus c'est facile.
    variable: 'duration_ms',
    startValue: 20000,
    minValue: 5000,
    maxValue: 30000,
    stepSizesByPhase: [4000, 2000, 1000, 500],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    maxTrials: 16,
    // 'down-easier' : higher value = easier (longer interval). Mêmes semantics
    // que visual-sweeps duration_ms.
    direction: 'down-easier',
};
/** Helpers de conversion intervalle ↔ trains/min. */
export function intervalToSpawnRate(intervalMs) {
    return 60000 / Math.max(1, intervalMs);
}
export function spawnRateToInterval(trainsPerMin) {
    return 60000 / Math.max(0.1, trainsPerMin);
}
function buildVariant(level) {
    if (level <= 10) {
        return {
            level,
            nColors: 3,
            nTracks: 2,
            occlusionMs: 0,
            dynamicColor: false,
            label: 'Routing simple',
        };
    }
    if (level <= 20) {
        return {
            level,
            nColors: 5,
            nTracks: 4,
            occlusionMs: 0,
            dynamicColor: false,
            label: 'Combinatoire',
        };
    }
    if (level <= 30) {
        return {
            level,
            nColors: 5,
            nTracks: 4,
            occlusionMs: 2000,
            dynamicColor: false,
            label: 'Tunnels',
        };
    }
    if (level <= 40) {
        return {
            level,
            nColors: 5,
            nTracks: 4,
            occlusionMs: 2000,
            dynamicColor: true,
            label: 'Updating',
        };
    }
    return {
        level,
        nColors: 5,
        nTracks: 4,
        occlusionMs: 2000,
        dynamicColor: true,
        label: 'Endurance',
    };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
export const COLOR_POOL = ['red', 'blue', 'green', 'yellow', 'purple'];
export function colorPoolForLevel(level) {
    const v = variantForLevel(level);
    return COLOR_POOL.slice(0, v.nColors);
}
/** Durées non-staircase. */
export const timing = {
    fixationMs: 500,
    /** Durée de la phase active (15 s spec). */
    trialDurationMs: 15000,
    feedbackMs: 600,
    itiMs: 700,
};
export const paradigmMeta = {
    slug: 'train-of-thought',
    paradigm: 'Divided attention routing (threaded cognition)',
    // Master mage interne, non affiché dans la copy externe.
    masterMage: 'Inori · Volta',
    category: 'air_attention',
    goal: 'Tu alternes plus vite, avec moins d\'erreurs : utile en cuisine, conduite, gestion familiale.',
};
//# sourceMappingURL=params.js.map